var map = {
	"./bender.webp": 6329,
	"./circle_square.webp": 9317,
	"./circles.webp": 6802,
	"./getintouch.webp": 7563,
	"./identitaDigitale.webp": 836,
	"./motoreInteresse.webp": 9529,
	"./notarizeMe.webp": 8067,
	"./opener.webp": 4694,
	"./phone-fifth.webp": 9715,
	"./phone-first.webp": 3620,
	"./phone-fouth.webp": 8612,
	"./phone-second.webp": 5078,
	"./phone-third.webp": 8319,
	"./squares.webp": 1407
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9743;